import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { UtilityService } from './utility.service';
import { ThirdPartyService } from '../third-party/third-party.service';
import def from 'ajv/dist/vocabularies/discriminator';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class PrivilegesService {

  baseUrl!: String;
  userPrivileges: any;
  dashboardPrivilege:any;
  jobDetailsPagePrivilege: any;

  private parseHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(
    private configService: ConfigService,
    public http: HttpClient,
    private utilityService: UtilityService,
    private thirdPartyService: ThirdPartyService,
  ) {
    this.baseUrl = this.configService.getBaseUrl()
  }

  public getLoginDetails() {
    return JSON.parse(localStorage.getItem('admin_Details') ?? '{}');
  }  

  public getUserPrivileges() {
    let sendingData = {
      userID: this.getLoginDetails()?.UserID
    };
    let url = this.baseUrl + '/User/GetUserPrivileges';
    let response = this.http.post(url, sendingData, this.parseHeaders);
    response.subscribe((res: any) => {
      const userPrivilegesStr = res?.ResponseData?.UserPrivileges;
      try {
        const userPrivilegesObj = JSON.parse(userPrivilegesStr);
        const statusAccess = userPrivilegesObj?.Servicenear?.StatusAccess;
        const privileges = userPrivilegesObj?.Servicenear?.Privileges;
        if (statusAccess) {
          localStorage.setItem('sevicenearStatus', JSON.stringify(statusAccess));
        }
        if (privileges) {
          localStorage.setItem('privileges', JSON.stringify(privileges));
        }
      } catch (err) {
        console.error("Failed to parse UserPrivileges:", err);
      }
    },
      (error: HttpErrorResponse) => {
      });
  }

  public getServicenearPrivilege(fuctionality: string, defaultState: boolean) {
    const privilegeString = localStorage.getItem('privileges');
    if(privilegeString && privilegeString !== "") {
      const privilegeObj = JSON.parse(privilegeString);
      if(privilegeObj[fuctionality] !== undefined){
        return privilegeObj[fuctionality];
      }
    }

    return defaultState;
  }

  public getUserId(){
    let userDetails = this.getLoginDetails();
    return userDetails.UserID;
  }

  public savePrivileges(formValue: any, userID: number) {
    let userJson: any = {
      Tobeonline: {
        Privileges: { ...formValue.Tobeonline },
      },
      Servicenear: {
        Privileges: {
          ...formValue.Servicenear,
          defaultStatus:
            formValue.Servicenear.defaultStatus == 'All'
              ? ''
              : formValue.Servicenear.defaultStatus,
        },
        StatusAccess: (formValue.allowedStatusesArray || []).map(
          (row: any) => ({
            status: row.status,
            allowed: true,
            canMoveTo: row.canMove || [],
          })
        ),
      },
    };

    let jsonString = JSON.stringify(userJson);
    let params = {
      userID: userID,
      userPrivilegeJson: jsonString,
      privilegeEditNarration: formValue.privilegeEditNarration,
    };
    return this.sellerSaveUserPrivilegeByUserID(params);
  }

  public sellerSaveUserPrivilegeByUserID(params: any) {
    let sendingData = {
      userID: params.userID,
      userPrivilegeJson: params.userPrivilegeJson,
      updatedBy: this.getLoginDetails()?.UserID,
      privilegeNarration: params.privilegeEditNarration,
    };
    let url = this.baseUrl + '/User/SellerSaveUserPrivilegeByUserID';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getPrivilegeEditHistory(userID: any) {
    let sendingData = {
      userID: userID,
    };
    let url = this.baseUrl + '/User/GetUserPrivilegeEditHistory';
    return this.http.post(url, sendingData, this.parseHeaders);
  }

  public getUserPrivilegesByID(userID: any) {
    let sendingData = {
      userID: userID,
    };
    let url = this.baseUrl + '/User/GetUserPrivileges';
    return this.http.post(url, sendingData, this.parseHeaders);
  }
  
  public convertDateFormatDetails(unixTimestamp: number) {
    return moment.unix(unixTimestamp).local().format("DD MMM YY, hh:mm a");
  }
}
